import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { SportyPeopleBadge } from "@/components/SportyPeople";

export default function AccessGate() {
  const { branding, grantAccess } = useApp();
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/access/verify", { code });
      grantAccess(data.token);
      toast.success("Acceso correcto");
      navigate("/calendario");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Código incorrecto");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(https://images.pexels.com/photos/6985267/pexels-photo-6985267.jpeg?auto=compress&cs=tinysrgb&w=1600)` }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-[#003284]/85 via-[#003284]/70 to-[#003a99]/80" />
      <form
        onSubmit={submit}
        data-testid="access-form"
        className="relative z-10 w-full max-w-md bg-white/95 backdrop-blur-xl rounded-3xl shadow-2xl p-8 sm:p-10"
      >
        <div className="text-center mb-8">
          <h1 className="text-3xl sm:text-4xl font-black brand-navy leading-none">Actividades al aire libre</h1>
          <p className="text-lg sm:text-xl font-bold text-slate-500 mt-1.5">Grupos de empresa</p>
          {branding?.logo_url && <img src={branding.logo_url} alt="Repsol" className="h-12 w-auto mx-auto mt-5" />}
          <div className="mt-3 flex justify-center"><SportyPeopleBadge /></div>
        </div>
        <p className="text-center text-slate-500 mb-8">
          Introduce el código de acceso para ver el calendario de actividades.
        </p>
        <label className="text-sm font-bold text-slate-700 mb-2 flex items-center gap-2">
          <Lock size={16} className="brand-navy" /> Código de acceso
        </label>
        <input
          data-testid="access-code-input"
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Escribe el código"
          className="w-full rounded-2xl border-2 border-slate-200 focus:border-[#003284] outline-none px-5 py-4 text-lg transition-colors"
          autoFocus
        />
        <button
          data-testid="access-submit-btn"
          disabled={loading || !code}
          className="mt-6 w-full bg-brand-orange hover:bg-[#E56A15] disabled:opacity-50 text-white font-bold text-lg rounded-full py-4 shadow-lg transition-colors flex items-center justify-center gap-2"
        >
          {loading ? <Loader2 className="animate-spin" size={20} /> : "Entrar"}
        </button>
      </form>
    </div>
  );
}
